import { render, staticRenderFns } from "./EstablishmentDashboard.vue?vue&type=template&id=24def5be&scoped=true&"
import script from "./EstablishmentDashboard.vue?vue&type=script&lang=js&"
export * from "./EstablishmentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentDashboard.vue?vue&type=style&index=0&id=24def5be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24def5be",
  null
  
)

export default component.exports